const getters = {
  getMutatinTypes: state => state.mutatinTypes,
  sceneInitProgress: state => state.app.sceneInitProgress,
  calcStore: state => state.calc,
  login: state => state.app.login,
  config: state => state.app.config,
}
export default getters
